import { AfterViewInit, Component, ElementRef, NgZone, OnDestroy, ViewChild, ViewEncapsulation } from '@angular/core';
import { Box, SafeArea } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { UnitService } from '@public/src/application/services/unit.service';
import { ScreenAccount } from '@view/view_settings/screen_account.component';
import { createRoot, Root } from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { sharedResolution } from '../../src/shared_resolution';
import { StartupService } from '../app/Services/app/startup.service';
import { CellulaProviderWrapper } from './cellula_provider_wrapper.component';

const containerElementName = 'reactHomeComponent';

@Component({
	standalone: false,
	selector: 'my-account-component',
	template: `
		<semantic-view>
			<header-component header></header-component>
			<div class="wrapper-container" #${containerElementName}></div>
			<footer-component footer></footer-component>
		</semantic-view>
	`,
	encapsulation: ViewEncapsulation.None,
})
export class MyAccountWrapperComponent implements OnDestroy, AfterViewInit {
	@ViewChild(containerElementName, { static: false }) containerRef: ElementRef;

	private root: Root;
	public extraHeaderHeight: boolean = false;

	constructor(private readonly ngZone: NgZone) {}

	ngAfterViewInit() {
		this.render();
	}

	ngOnDestroy() {
		this.root?.unmount();
	}

	private async render() {
		const unitService = sharedResolution.resolve(UnitService);

		const root = createRoot(this.containerRef.nativeElement);
		this.root = root;

		this.ngZone.runOutsideAngular(() => {
			root.render(
				<CellulaProviderWrapper useGlobals>
					<BrowserRouter>
						<Routes>
							<Route path={unitService.rootUnit.route}>
								<Route
									path='my-account/*'
									element={
										<SafeArea maxWidth='600px'>
											<Box width='100%' padding={`${tokens.spacing.x4} 0`}>
												<ScreenAccount />
											</Box>
										</SafeArea>
									}
								/>
							</Route>
						</Routes>
					</BrowserRouter>
				</CellulaProviderWrapper>,
			);
		});
	}
}
